export default __webpack_public_path__ + "static/OpenSans-Italic-VariableFont_wdth,wght-81a74304bda5ab8fa33a2c067f9b5f18.ttf";